import { Platform } from 'react-native';

import { getCurrentCommitHash } from 'utils/environment';

// This is the time we block the app for waiting for LD connection
// if timeout we let the user use the app with default flag values
export const initializationTimeoutSecondsDefault = 10;

export const privateAttributes = [
  'email',
  'firstName',
  'lastName',
  'name',
  'dateOfBirth',
  'dob',
  'phoneNumber',
  'zipcode',
];

export const commit = getCurrentCommitHash();

export const mobileOS = Platform.OS;

export const language = 'en';

export * from './platform-specific';
export * from './country-specific';
